import React from "react";
import { Bars3Icon } from "@heroicons/react/24/outline";
import { useAuth } from "../contexts/AuthContext";

interface HeaderProps {
  onMenuClick: () => void;
  onCollapseToggle?: () => void; // deprecated here
  isSidebarCollapsed?: boolean; // deprecated here
}

export const Header: React.FC<HeaderProps> = ({ onMenuClick }) => {
  const { adminUser } = useAuth();
  const roleLabel = adminUser?.role === "superadmin" ? "Суперадмин" : "Админ";
  return (
    <header className="bg-white/80 backdrop-blur border-b border-gray-200">
      <div className="flex items-center justify-between px-4 py-3 lg:px-6">
        <div className="flex items-center gap-2">
          <button
            onClick={onMenuClick}
            className="lg:hidden p-2 rounded-md text-gray-500 hover:text-gray-700 hover:bg-gray-100"
          >
            <Bars3Icon className="h-6 w-6" />
          </button>
          <div className="ml-2 lg:ml-0">
            <h1 className="text-lg font-semibold text-gray-900">
              Админ панель
            </h1>
          </div>
        </div>

        <div className="flex items-center space-x-4">
          <div className="hidden sm:flex items-center space-x-2">
            <div className="h-8 w-8 bg-primary-100 rounded-full flex items-center justify-center">
              <span className="text-sm font-medium text-primary-700">
                {adminUser?.email?.[0]?.toUpperCase() || "?"}
              </span>
            </div>
            <div className="flex flex-col">
              <span className="text-sm font-medium text-gray-900">
                {adminUser?.email || "—"}
              </span>
              <span className="text-xs text-gray-500">{roleLabel}</span>
            </div>
          </div>
        </div>
      </div>
    </header>
  );
};
